import { useQuery } from '@tanstack/react-query'
import ky from 'ky'

export function useTimestamp() {
  const { data } = useQuery({
    queryKey: ['timestamp'],
    queryFn: async () => {
      const res = await ky.get('/time.js?')
      return new Date(Number(new URL(res.url).searchParams.get('ts')) * 1000)
    },
    refetchInterval: 60_000,
    staleTime: Infinity,
  })
  return data!
}
